import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=b2e8471a&scoped=true&"
import script from "./PaymentMethod.vue?vue&type=script&lang=js&"
export * from "./PaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e8471a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2e8471a')) {
      api.createRecord('b2e8471a', component.options)
    } else {
      api.reload('b2e8471a', component.options)
    }
    module.hot.accept("./PaymentMethod.vue?vue&type=template&id=b2e8471a&scoped=true&", function () {
      api.rerender('b2e8471a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/Dashboard/PaymentMethod.vue"
export default component.exports